import React from 'react'

import icon_fb from '../../images/facebook-dieetclub-dieetpuntclub.png'


export default class extends React.Component {

  render() {
    return (
      <div className="socials polymedia-footer">
        <a href="https://www.facebook.com/DieetPuntClub/" target="_blank" rel="noopener noreferrer">
          <span className="img-wrap"><img src={icon_fb} alt="Facebook" /></span>
          <span className="txt-wrap">@DieetPuntClub</span>
        </a>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/StartFooterSocials.js